import React from 'react';
import { Box } from '@material-ui/core';
import {
  TextFieldCom,
  RadioFieldCom,
} from '../../../../label_manage/components/FormType';

const updateStrategyList = [{ label: '手动更新', value: '1' }];
export default ({ queryType, control, errors, setValue }) => {
  return (
    <Box display="flex" gap="0 48px">
      <Box flex="1" display="flex" flexDirection="column" gap="40px 0">
        <TextFieldCom
          autoFocus={true} //If true, the input element is focused during the first mount.
          initLabel={true} //自定义的label是否显示
          showLabel={false} //是否需要显示label
          placeholder="请输入人群名称且不超过20个字符"
          queryType={queryType} //detail不可编辑用于详情
          helperText="" //用于校验的提醒文字
          name="title"
          label="人群名称" //label
          control={control}
          errors={errors}
          setValue={setValue}
          isPositiveNumber={false} //true 只能输入正数，false可以输入负数
          isParseInt={false} //true 只能输入正整数，false可以输入小数
          rules={{
            required: true, //是否是必填项true 必填 false 非必填
            maxLength: 20,
          }}
        />
        <RadioFieldCom
          initLabel={true} //自定义的label是否显示
          label="更新方式" //label
          queryType="detail" //detail不可编辑用于详情
          control={control}
          lWidth="auto"
          name="updateStrategy"
          typeList={updateStrategyList}
        />
      </Box>
      <Box flex="1">
        <TextFieldCom
          initLabel={false} //自定义的label是否显示
          showLabel={true} //是否需要显示label
          placeholder="最大长度不超过200个字符"
          queryType={queryType} //detail不可编辑用于详情
          helperText="" //用于校验的提醒文字
          name="remark"
          label="备注" //label
          control={control}
          errors={errors}
          setValue={setValue}
          isPositiveNumber={false} //true 只能输入正数，false可以输入负数
          isParseInt={false} //true 只能输入正整数，false可以输入小数
          rules={{
            required: false, //是否是必填项true 必填 false 非必填
            maxLength: 200,
          }}
          multiline
          rows={8}
          variant="outlined"
          className={
            queryType === 'detail'
              ? 'textField-area-wrap textField-area-line-wrap'
              : 'textField-area-wrap'
          }
        />
      </Box>
    </Box>
  );
};
